import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=5b70ba1a&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=5b70ba1a&lang=scss&scoped=true&"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70ba1a",
  null
  
)

export default component.exports